import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-484468b3")

_pushScopeId("data-v-484468b3")
const _hoisted_1 = { class: "search-filter-container" }
const _hoisted_2 = {
  key: 0,
  class: "total-container"
}
const _hoisted_3 = {
  role: "group",
  class: "search-input form-group"
}
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "포인트 검색")
], -1)
const _hoisted_6 = { class: "search-result-container" }
const _hoisted_7 = { class: "point-info-card" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  id: "mapContainer",
  style: {"width":"100%","height":"100%"}
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Loading = _resolveComponent("Loading")

  return (_openBlock(), _createBlock("div", {
    style: [{"position":"relative"}, _ctx.fullHeight]
  }, [
    _createVNode(_component_Loading, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", null, [
        (_ctx.totalPointsCount>0)
          ? (_openBlock(), _createBlock("p", _hoisted_2, "조회된 포인트는 총 : " + _toDisplayString(_ctx.totalPointsCount) + "입니다.", 1))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("input", {
              type: "text",
              class: "form-control",
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeSearchKey && _ctx.changeSearchKey(...args)))
            }, null, 32)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("ul", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchResults, (searchPoint) => {
              return (_openBlock(), _createBlock("li", {
                key: searchPoint.id,
                onClick: ($event: any) => (_ctx.gotoPoint(searchPoint))
              }, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("p", null, _toDisplayString(searchPoint.name), 1),
                  _createVNode("span", null, _toDisplayString(searchPoint.address), 1)
                ])
              ], 8, ["onClick"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _hoisted_8
  ], 4))
})